const Roles = {
	User: 'user',
	Wijkcoordinator: 'wijkcoordinator',
	Exporter: 'exporter',
	Administrator: 'administrator',
	Wijkagent: 'wijkagent',
	Gemeente: 'gemeente',
	Politie: 'politie'
}

function hasRole(user, role) {
	if (!user || !user.roles) return false;
	return user.roles.indexOf(role) !== -1;
}

function getIconForRole(role) {
	switch (role) {
		case Roles.User:
			return 'person';
		case Roles.Wijkcoordinator:
			return 'shield';
		case Roles.WijkAgent:
			return 'security';
		case Roles.Gemeente:
			return 'account-balance';
		case Roles.Politie:
			return 'local-police';
		default:
			return 'question-mark';
	}
}

export default {
	Roles,
	hasRole,
	getIconForRole
}
